import { lazy } from 'react';

// Mensajes que emiten los navegadores cuando un chunk dinámico desapareció
// (típico tras un deploy: los hashes de los assets cambian).
const CHUNK_LOAD_ERROR_PATTERNS = [
  /Failed to fetch dynamically imported module/i,
  /error loading dynamically imported module/i,
  /Importing a module script failed/i,
  /is not a valid JavaScript MIME type/i, // Safari iOS: chunk stale devuelve HTML 404
];

const isChunkLoadError = (error) =>
  CHUNK_LOAD_ERROR_PATTERNS.some((re) => re.test(error?.message || ''));

const lazyWithRetry = (importFn) =>
  lazy(async () => {
    const alreadyRefreshed = JSON.parse(
      window.sessionStorage.getItem('page-has-been-force-refreshed') || 'false'
    );

    try {
      const mod = await importFn();
      window.sessionStorage.setItem('page-has-been-force-refreshed', 'false');
      return mod;
    } catch (error) {
      // Solo recargamos cuando el error es de chunk stale y todavía no recargamos.
      // Si no es un error de chunk (p. ej. un crash real al evaluar el módulo),
      // propagamos al ErrorBoundary como siempre.
      if (isChunkLoadError(error) && !alreadyRefreshed) {
        window.sessionStorage.setItem('page-has-been-force-refreshed', 'true');
        window.location.reload();
        // Mantenemos el Suspense en estado pendiente mientras el navegador recarga.
        // Si propagáramos el error, el ErrorBoundary mostraría su fallback por
        // un instante y Sentry registraría un falso positivo.
        return new Promise(() => {});
      }
      throw error;
    }
  });

export default lazyWithRetry;
